import React, { useContext } from 'react'
import WorkFlowTable from './component/WorkflowTable/WorkFlowTable';
import WorkFlowTableForeign from './Foreign/WorkFlowTableForeign';
import { AppContext } from 'AppProvider/AppContext';
import WorkFlowTableEmerging from './emerging/WorkFlowTableEmerging';
import WorkFlowTableCrm from './crm/WorkFlowTableCrm';

const WorkFlow = () => {
  const { workflowProcess } = useContext(AppContext);

  return (
    <>
      {workflowProcess?.processName === "foreign" ? (
        <WorkFlowTableForeign />
      ) : workflowProcess?.processName === "emerging" ? (
        <WorkFlowTableEmerging />
      ) : workflowProcess?.processName === "crm" ? (
        <WorkFlowTableCrm />
      ) : (
        <WorkFlowTable />
      )}
    </>
  );
};

export default WorkFlow;